// REPORT landing page component
//*******************************************************************
//*******************************************************************
//IMPORTS:
//EXTERNAL & PACKAGE
import $ from 'jquery'
import Popper from 'popper.js'
import React from 'react'
import {graphql, Link} from 'gatsby'
//COMPONENT DEPENDENCIES
import Heading from '../components/heading'
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import PageHeader from '../components/PageHeader'
import FullWidthImage from '../components/FullWidthImage'
import TextBlock from '../components/textblock'
import ContentBlock from '../components/ContentBlock'
import HyperLink from '../components/HyperLink'
import Helmet from "react-helmet"
//*******************************************************************
//*******************************************************************        
const reportPage = ({data}) => {
    
    const report = data.report.edges
    
    return (
        
        <div>
            
            <Helmet>
            <title>NJCCIC Report</title> 
             <meta name="description" content="Key information on reporting acyber indicent or data breach"/>
            </Helmet> 
        
            <Heading/>
        
            <Navbar/>
        
            {report.map(({ node: {page_title, introductory_text, header_image, header_image_alt_text, content_group, general_text} }) => (
                
                <div class="container-fluid"> 
        
                    <PageHeader elementClass="pageHeader centerText" title={page_title}/>
                    
                    <div class="container containerWidth">
                        
                        <div class="row">
        
                            <TextBlock elementClass="standardText introPadding" text={introductory_text}/>
                            
                        </div>
                        
                    </div>
        
                    <ContentBlock testClass="testClass container containerWidth" elementClass="col-12 col-md standardText blocks block2" dangerousClass="standardText blockText margin" headerStyles="header contentTitle" data={content_group}/>
                    
                    <div class="container containerWidth">
                        
                        <div class="row">
                            
                            <TextBlock elementClass="standardText introPadding" text={general_text} dangerousClass=""/>
                            
                        </div>
                        
                    </div>
                    
                    <FullWidthImage src={header_image} alt={header_image_alt_text}/>
                    
                </div>
        
            ))}
            
            <Footer/>
            
            
        </div>
    )
}
//*******************************************************************
//*******************************************************************
//data query
export const query = graphql`
    query {
        report: allButterPage(filter: {slug: { eq: "report" } }) {
            edges {
                node {
                    slug
                    seo_title
                    page_title   
                    introductory_text
                    clickable_text
                    clickable_text_url
                    header_image
                    header_image_alt_text
                    content_group {
                        section_name
                        text
                        icon
						alt_text
                    }
                    general_text                     
                }
            }
        }
    }
`
export default reportPage
//*******************************************************************
//*******************************************************************